import React from "react";
import { Flex } from "@chakra-ui/react";
import PathPickLandingCtaButton from "@/features/pathpick/features/landing/components/PathPickLandingCtaButton";
import { PathPickLandingCta } from "@/features/pathpick/features/landing/hooks/usePathPickLandingCta";

interface Props {
  cta: PathPickLandingCta;
}

/**
 * 하단 고정 CTA.
 *
 * 로그인했지만 아직 첫 결제를 하지 않은 사용자에게만 띄운다(체험 유도).
 * 이 바가 떠 있는 동안 FAQ 아래 CTA는 감춘다 — 같은 버튼이 두 번 겹치지 않게 한다(index.tsx).
 */
function PathPickLandingFloatingBar({ cta }: Props) {
  if (!cta.showFloatingBar) {
    return null;
  }

  return (
    <Flex
      position={"fixed"}
      // PWA 설치 안내 배너 위로 띄운다(배너가 없으면 변수가 0px).
      bottom={{
        base: "calc(16px + var(--pwa-banner-height, 0px))",
        lg: "calc(28px + var(--pwa-banner-height, 0px))",
      }}
      left={0}
      right={0}
      justifyContent={"center"}
      paddingX={"20px"}
      zIndex={9000}
      pointerEvents={"none"}
    >
      <Flex pointerEvents={"auto"} boxShadow={"0 8px 24px rgba(0, 0, 0, 0.18)"} borderRadius={"full"}>
        <PathPickLandingCtaButton
          action={cta.floating}
          icon={"package"}
          shape={"pill"}
          size={"lg"}
        />
      </Flex>
    </Flex>
  );
}

export default PathPickLandingFloatingBar;
